import React from 'react';

interface HierarchyNode {
  id: string;
  name: string;
  level_type: string;
  level: number;
  parent_id?: string;
  status: string;
  children?: HierarchyNode[];
  expanded?: boolean;
}

interface HierarchyActionModalsProps {
  selectedNode: HierarchyNode | null;
  hierarchy: HierarchyNode[];
}

export const HierarchyActionModals: React.FC<HierarchyActionModalsProps> = ({
  selectedNode: _selectedNode,
  hierarchy: _hierarchy,
}) => {
  return (
    <>
      {/* No modals needed - delete happens immediately */}
    </>
  );
};
